import type { Parceiro } from "./tipos"

// Metadados (metadados.com.br), sistema de DP e RH que leva o consignado aos clientes dela. Cores e
// fonte tiradas do site deles e do logo oficial.
//
// Uma troca deliberada, como a do rosa da Newbe: o azul do site é #4e7cdd, mas branco sobre ele dá
// 4,00:1. #3f6fd6 é o mesmo matiz, só a luminosidade que baixa o mínimo para passar (4,71:1). O azul
// original fica nos gráficos, que não carregam texto — e fica longe do vermelho de "barrado".
export const METADADOS: Parceiro = {
    slug: "metadados",
    nome: "Metadados",
    doParceiro: "da Metadados",
    comArtigo: "a Metadados",
    tituloDaAba: "Metadados · Portal do Empregador",
    // O ícone do próprio logo oficial, recortado sem o nome.
    favicon: "/brand/metadados-favicon.png",
    // O arquivo oficial é vertical, com o slogan embaixo: a 28px de altura o nome sumiria. Esta é a
    // mesma arte montada na horizontal (ícone ao lado do nome, sem o slogan), como o site deles usa.
    // A versão escura recolore só o nome cinza; o ícone azul fica intacto.
    marca: {
        tipo: "imagem",
        claro: "/brand/metadados.webp",
        escuro: "/brand/metadados-branco.webp",
        alt: "Metadados",
    },
    dominios: [],
    operadoPelaFazCred: true,
    tema: {
        claro: {
            brand: "#3f6fd6",
            "brand-ink": "#ffffff",
            "brand-strong": "#2f5bbf",
            "brand-wash": "#e6eeff",
            data: "#4e7cdd",
            page: "#f7f8fa",
            card: "#ffffff",
            sunk: "#eef2fb",
            ink: "#313130",
            soft: "#3f3f3e",
            faint: "#6b6b6a",
            line: "#e3e7ef",
            "line-strong": "#c7cedb",
        },
        escuro: {
            brand: "#7fa3f0",
            "brand-ink": "#111317",
            "brand-strong": "#a3bdf5",
            "brand-wash": "#18264a",
            data: "#7fa3f0",
            page: "#0f1115",
            card: "#181b22",
            sunk: "#222631",
            ink: "#f3f4f6",
            soft: "#dde1e8",
            faint: "#aab2c0",
            line: "#2a2f3b",
            "line-strong": "#404757",
        },
    },
    fontes: {
        titulo: "Ubuntu, ui-sans-serif, system-ui, sans-serif",
        texto: "Ubuntu, ui-sans-serif, system-ui, sans-serif",
        numeros: "Ubuntu, ui-sans-serif, system-ui, sans-serif",
        // Ubuntu não tem versão variável nem 600/800: o navegador cai no 500 e no 700, os pesos
        // mais próximos.
        carregar: () =>
            Promise.all([
                import("@fontsource/ubuntu/400.css"),
                import("@fontsource/ubuntu/500.css"),
                import("@fontsource/ubuntu/700.css"),
            ]),
    },
}
